import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-popup-down-time',
  imports: [CommonModule],
  templateUrl: './popup-down-time.html',
  styleUrl: './popup-down-time.scss',
})
export class PopupDownTime {
  // systemDownIcon = 'assets/images/system-down.svg';
  // exclaimIcon = 'assets/images/exclaim.svg';
  pauseIcon = 'assets/images/pause-popup-icon.svg';
  pauseIconMini = 'assets/images/pause-popup-mini-icon.svg';

  @Input() theme: string = 'light';

  constructor() { }

  get isDarkTheme(): boolean {
    return this.theme === 'dark';
  }

}
